module.exports = __webpack_public_path__ + "media/images/city/076-gateway-of-india-41ea85028c835ba1c35a17071ae4b86d.svg";